const injectFbSDKScript = () => {
    (function (d, s, id) {
        var js,
            fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) {
            return;
        }
        js = d.createElement(s);
        js.id = id;
        js.src = "https://connect.facebook.net/en_US/sdk.js";
        fjs.parentNode.insertBefore(js, fjs);
    })(document, "script", "facebook-jssdk");
};


export default new Promise((resolve, reject) => {
    window.fbAsyncInit = function () {
        window.FB.init({
            // Find your App ID on https://developers.facebook.com/apps/
            appId: process.env.FACEBOOK_APP_ID,
            cookie: false,
            localStorage: false,
            xfbml: false,
            version: process.env.FACEBOOK_API_VERSION,
            status: true
        });
    
        window.FB.AppEvents.logPageView();
        resolve(window.FB);
    };
    
    injectFbSDKScript();
})



